import { Button } from "@/components/ui/button"
import {
    Sheet,
    SheetClose,
    SheetContent,
    SheetDescription,
    SheetFooter,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
} from "@/components/ui/sheet"
import AddTeam from "../../teams/add-team/AddTeam";

const SHEET_SIDES = ["top"] as const

export default function SheetSide() {
    return (
        <div className="flex flex-wrap gap-2">
            {SHEET_SIDES.map((side) => (
                <Sheet key={side}>
                    <SheetTrigger asChild>
                        <Button variant="outline" className="capitalize">
                            Add your team
                        </Button>
                    </SheetTrigger>
                    <SheetContent side={side}>
                        <SheetHeader>
                            {/*
                            <SheetTitle>Edit profile</SheetTitle>
                            <SheetDescription>
                                Make changes to your profile here. Click save when you&apos;re
                                done.
                            </SheetDescription>
                            */}
                        </SheetHeader>
                        <AddTeam />
                        {/*
                        <SheetFooter>
                            <Button type="submit">Save changes</Button>
                            <SheetClose asChild>
                                <Button variant="outline">Cancel</Button>
                            </SheetClose>
                        </SheetFooter>
                        */}
                    </SheetContent>
                </Sheet>
            ))}
        </div>
    )
}
